import { Box, Container, Text, Stack, Group } from '@mantine/core';
import { Link } from 'react-router-dom';
import { ManifestusLogo } from './ManifestusLogo';
import { trackLinkClick } from '../../analytics';

export function PublicFooter() {
  return (
    <Box
      component="footer"
      py={48}
      style={{ borderTop: '1px solid #f1f5f9' }}
    >
      <Container size="lg">
        <Stack align="center" gap={12}>
          <ManifestusLogo h={16} variant="dimmed" />
          <Text size="xs" c="#94a3b8">
            © {new Date().getFullYear()} Manifestus. All rights reserved.
          </Text>
          <Text size="xs" c="#94a3b8" ta="center">
            Built on{' '}
            <Text
              component="a"
              href="https://openclaw.ai"
              target="_blank"
              rel="noopener noreferrer"
              size="xs"
              c="#64748b"
              td="none"
              style={{ fontWeight: 500 }}
              onClick={() => trackLinkClick('OpenClaw', 'https://openclaw.ai', true)}
            >
              OpenClaw
            </Text>
          </Text>
          <Group gap={16} mt={4}>
            <FooterLink to="/terms">Terms</FooterLink>
            <FooterLink to="/privacy">Privacy</FooterLink>
          </Group>
        </Stack>
      </Container>
    </Box>
  );
}

function FooterLink({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <Text
      component={Link}
      to={to}
      size="xs"
      c="#94a3b8"
      td="none"
      style={{ transition: 'color .2s' }}
      onClick={() => trackLinkClick(String(children), to, false)}
      onMouseEnter={(e: React.MouseEvent<HTMLAnchorElement>) => { e.currentTarget.style.color = '#475569'; }}
      onMouseLeave={(e: React.MouseEvent<HTMLAnchorElement>) => { e.currentTarget.style.color = '#94a3b8'; }}
    >
      {children}
    </Text>
  );
}
